module.exports = __webpack_public_path__ + "img/patelp.655d1206.jpg";